"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@emotion/core");
var _globalStyles = _interopRequireDefault(require("./globalStyles"));
var _size = _interopRequireDefault(require("../constants/size"));
var _ThemeContext = _interopRequireDefault(require("./ThemeContext"));
var Theme = function Theme(_ref) {
  var children = _ref.children,
    gridDebugger = _ref.gridDebugger,
    fontFace = _ref.fontFace,
    principles = _ref.principles,
    uiElements = _ref.uiElements,
    patterns = _ref.patterns,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? _size["default"].contentMaxWidth : _ref$maxWidth,
    _ref$gridConfig = _ref.gridConfig,
    gridConfig = _ref$gridConfig === void 0 ? {
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      max: 12,
      smRail: 12,
      mdRail: 12,
      lgRail: 12,
      xlRail: 12,
      maxRail: 12
    } : _ref$gridConfig;
  return _react["default"].createElement(_ThemeContext["default"].Provider, {
    value: {
      maxWidth: maxWidth,
      gridConfig: gridConfig
    }
  }, _react["default"].createElement(_core.Global, {
    styles: (0, _globalStyles["default"])({
      fontFace: fontFace,
      principles: principles,
      uiElements: uiElements,
      patterns: patterns
    })
  }), gridDebugger, children);
};
Theme.displayName = 'Theme';
var _default = Theme;
exports["default"] = _default;
Theme.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Theme",
  "props": {
    "maxWidth": {
      "defaultValue": {
        "value": "size.contentMaxWidth",
        "computed": true
      },
      "required": false
    },
    "gridConfig": {
      "defaultValue": {
        "value": "{\n  sm: 12,\n  md: 12,\n  lg: 12,\n  xl: 12,\n  max: 12,\n  smRail: 12,\n  mdRail: 12,\n  lgRail: 12,\n  xlRail: 12,\n  maxRail: 12,\n}",
        "computed": false
      },
      "required": false
    }
  }
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["layout/Theme.tsx"] = {
    name: "Theme",
    docgenInfo: Theme.__docgenInfo,
    path: "layout/Theme.tsx"
  };
}